/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import IconButton from '@mui/material/IconButton';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import Tooltip from '@mui/material/Tooltip';

interface ButtonEMIconProps {
  showEMHighlight: boolean;
  setShowEMHighlight: (value: boolean) => void;
}
export function ButtonEMIcon({ showEMHighlight, setShowEMHighlight }: ButtonEMIconProps) {
  return (
    <Tooltip title="Add emergency medicine info">
      <IconButton
        type="button"
        aria-label="button-em"
        data-testid="button-em-icon"
        onClick={() => {
          setShowEMHighlight(!showEMHighlight);
        }}
      >
        <EMSvgIcon fillOpacity={showEMHighlight ? 1 : 0.3} />
      </IconButton>
    </Tooltip>
  );
}
export function EMSvgIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M26 0H0V16H26V0Z" fill="#FF6666" />
      <path d="M3 13V3H10V5.1875H5.63685V6.90631H9.63957V9.0938H5.63685V10.8125H9.98104V13H3Z" fill="white" />
      <path
        d="M12 3H15.094L17.432 9.874H17.46L19.672 3H22.766V12.996H20.708V5.912H20.68L18.23 12.996H16.536L14.086 5.982H14.058V12.996H12V3Z"
        fill="white"
      />
    </SvgIcon>
  );
}
